<template>
 <page-container>
  <template v-slot:page-fixed-header>
    <span class="text-h5 font-weight-bold ml-3 page-header">
      {{ $t("UserManual") }}
      </span>      
      <v-spacer></v-spacer>
      <a-btn        
        color = "primary"
        :disabled="page > 1 ? false : true"        
        @click="page > 1 ? page-- : 1"
        
      >
        <v-icon>mdi-chevron-left</v-icon> {{ $t("Previous") }}</a-btn
      >
      <v-spacer></v-spacer>
      <span v-if="numPages" class="font-weight-bold mt-2" > {{ page }} / {{ numPages ? numPages : "∞" }}</span>
      <v-spacer></v-spacer>
      <a-btn
        color = "primary"
        :disabled="page < numPages ? false : true"
        @click="page < numPages ? page++ : 1"
        
      >
        {{ $t("Next") }}<v-icon>mdi-chevron-right</v-icon></a-btn
      >
      <v-spacer></v-spacer>
  </template>
  <template v-slot:page-content>
      <v-row>
        <v-col cols="12">
          <PDFViewer
            :documentPath="pdfFilePath"
            :page.sync="page"
            v-model="numPages"
          />
        </v-col>
      </v-row>
      <Loader :loading="loaderloading" :message="loaderText"></Loader>
  </template>
 </page-container>
</template>

<script>
import PDFViewer from "../components/dashboard/PDFViewer.vue";
import Loader from "@/components/Loader.vue";
export default {
  name: "UserManual",
  components: {
    PDFViewer,
    Loader,
  },
  data() {
    return {
      pdfFilePath: this.$route.query.content,
      page: 1,
      numPages: 0,
      scale: "page-width",
      routeQuery: null,
      manuals: {
        Meeting: {
          en : "Manual_E_Meeting.pdf",
          ja: "Manual_Meeting.pdf"
        },
        Agenda : {
          en : "Manual_E_Agenda.pdf",
          ja: "Manual_J_Agenda.pdf"
        },
        Calendar: {
          en : "Manual_E_Calendar.pdf",
          ja: "Manual_J_Calendar.pdf"
        },
        Documents : {
          en : "Manual_E_Document.pdf",
          ja: "Manual_J_Document.pdf"
        },
        Calendar: {
          en : "Manual_E_Calendar.pdf",
          ja: "Manual_J_Calendar.pdf"
        },
        People : {
          en : "Manual_E_People.pdf",
          ja: "Manual_J_People.pdf"
        },
        Survey: {
          en : "Manual_E_Survey.pdf",
          ja: "Manual_J_Survey.pdf"
        },
        Task : {
          en : "Manual_E_Task.pdf",
          ja: "Manual_J_Task.pdf"
        },
        TopicCategory: {
          en : "Manual_E_Topic Category.pdf",
          ja: "Meeting.Structure.Sample.pdf"
        }
      }
    };
  },
  created() {
    this.pdfFilePath = this.$route.query.content;
    this.routeQuery = this.$route.query;
  },
  watch: {
    "$i18n.locale": {
      immediate: true,
      async handler(newValue) {
        this.pdfFilePath = this.manuals[this.routeQuery.id][newValue];        
        this.$router.push(`/usermanual?content=${this.pdfFilePath}&id=${this.routeQuery?.id}`);
        this.$router.go();
      }
    }
  },
  computed: {
    loaderloading() {
      return this.numPages <= 0;
    },
    loaderText() {
        return this.$t("LoaderText");
    },
  },
};
</script>
